export const SIDEBAR_TOGGLE = { key: 'b', meta: true, ctrl: true } as const;
export const COMMAND_PALETTE = { key: 'k', meta: true, ctrl: true } as const;

export const GO_DASHBOARD = { key: 'd', prefix: 'g' } as const;
export const GO_ENTITIES = { key: 'e', prefix: 'g' } as const;
export const GO_COMPLIANCE = { key: 'c', prefix: 'g' } as const;
export const CREATE_NEW = { key: 'n', prefix: 'c' } as const;

export function formatShortcut(keys: string[]): string {
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
  return keys
    .map((key) => (key === 'mod' ? (isMac ? '⌘' : 'Ctrl') : key))
    .join(isMac ? '' : '+');
}
